import { Flex, Icon } from '@chakra-ui/react';
import { CheckCircle } from '@kula-ai/icons/dual-tone/CheckCircle';
import { KText } from '../../text';

export const CustomOptions = (props) => {
  const {
    isSelected,
    isFocused,
    children,
    innerRef,
    innerProps,
    data,
    options,
    isDisabled,
    selectProps,
  } = props;

  const currentIndex = options.findIndex((opt) => opt.value === data.value);
  const isLast = currentIndex === options.length - 1;

  const optionTruncate = selectProps?.extraProps?.optionTruncate;
  const optionEnableTooltip = selectProps?.extraProps?.optionEnableTooltip;
  const optionMaxWidth = selectProps?.extraProps?.optionMaxWidth;

  return (
    <Flex
      ref={innerRef}
      {...innerProps}
      alignItems="center"
      justifyContent="space-between"
      bg={
        isSelected ? 'secondary-25' : isFocused ? 'secondary-25' : 'transparent'
      }
      padding="12px"
      cursor={isDisabled ? 'not-allowed' : 'pointer'}
      opacity={isDisabled ? 0.5 : 1}
      _hover={{
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        bg: isDisabled ? 'transparent' : 'secondary-25',
      }}
      borderBottomWidth={isLast ? 'none' : '1px'}
      borderColor="border-color"
      pointerEvents={isDisabled ? 'none' : 'auto'}
    >
      <KText
        color={isDisabled ? 'gray.400' : undefined}
        isTruncated={optionTruncate}
        enableTooltip={optionEnableTooltip}
        maxW={optionMaxWidth}
        flex="1"
      >
        {children}
      </KText>
      {isSelected && (
        <Icon as={CheckCircle} h="18px" w="18px" color="primary-500"></Icon>
      )}
    </Flex>
  );
};
